import types from "../mutationType";
var state = {
    editData: {},
    openedMenuList: [],
    pageOpenedList: [],
    menuList: [],
    theme: 'dark',
    themeColor: '',
    meteoDataResolved: true,
    lang: 'zh-CN',
};
var mutations = (_a = {},
    _a[types.setMenuList] = function (state, payload) {
        state.menuList = payload;
    },
    _a[types.changeMenuTheme] = function (state, theme) {
        state.theme = theme;
    },
    _a[types.changeMainTheme] = function (state, mainTheme) {
        state.themeColor = mainTheme;
    },
    _a[types.openPage] = function (state, page) {
        //清空当前
        state.pageOpenedList.map(function (value) { return value.current = false; });
        //查找当前页面是否打开
        var currentPage = state.pageOpenedList.find(function (value) { return page.path === value.path; });
        if (currentPage) {
            currentPage.current = true;
        }
        else {
            page.current = true;
            state.pageOpenedList.push(page);
        }
    },
    _a[types.closePage] = function (state, path) {
        var index = state.pageOpenedList.findIndex(function (value) { return value.path === path; });
        if (index > 0) {
            state.pageOpenedList.splice(index, 1);
        }
    },
    _a[types.closeAllPage] = function (state) {
        state.pageOpenedList.splice(1, state.pageOpenedList.length - 1);
    },
    _a[types.closeOtherPage] = function (state) {
        var item = state.pageOpenedList.find(function (value) { return value.current; });
        if (state.pageOpenedList.length > 1) {
            state.pageOpenedList.splice(1, state.pageOpenedList.length - 1);
            if (state.pageOpenedList[0].path !== item.path)
                state.pageOpenedList.push(item);
        }
    },
    _a[types.setHomePage] = function (state, page) {
        if (state.pageOpenedList.length === 0)
            state.pageOpenedList.push(page);
        else
            state.pageOpenedList[0] = page;
    },
    _a[types.setTabTitle] = function (state, page) {
        var tab = state.pageOpenedList.find(function (value) { return value.path === page.path; });
        if (tab) {
            tab.title = page.title;
        }
    },
    _a[types.switchLang] = function (state, lang) {
        state.lang = lang;
    },
    _a);
export default {
    state: state,
    mutations: mutations
};
var _a;



//////////////////
// WEBPACK FOOTER
// ./src/store/module/um.ts
// module id = null
// module chunks = 